import React, { memo } from "react";
import scale from "../../utils/scale";
import Text from "../../components/Text";
import { SOURCE_ICON } from "../../images";
import { StyleSheet, View, Image } from "react-native";

interface InfoItemProps {
    title?: string;
    body?: string;
}

const InfoItem = memo(({ title, body }: InfoItemProps) => {
    return (
        <View >
            <View
                style={styles.mainContent}
            >
                {title && (
                    <View style={styles.contentDescription}>
                        <Image
                            source={SOURCE_ICON.infoCircle}
                            style={styles.toolIcon}
                        >
                        </Image>
                        <Text
                            size={14}
                            color='#273035'
                            marginLeft={15}
                            style={{
                                weight: '400',
                                letterSpacing: 0,
                                lineHeight: 18
                            }}
                        >
                            {title}
                        </Text>
                    </View>
                )}
                {body && (
                <Text
                    size={14}
                    color='#273035'
                    marginLeft={scale(60)}
                    lineHeight={20}
                >
                    {body}
                </Text>
                )}
            </View>
        </View>
    );
});

export default InfoItem;

const styles = StyleSheet.create({
    mainContent: {
        marginTop: 10,
        borderWidth: 1.5,
        borderRadius: 2,
        paddingVertical: 17,
        paddingHorizontal: 15,
        borderColor: '#F1BC02',
        flexDirection: 'column',
        backgroundColor: '#FFECAA',
    },
    contentDescription: {
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 10,
    },
    toolIcon: {
        width: 20,
        height: 20,
        tintColor: '#000',
    }
});
